import React, { useState } from 'react';
import { toast } from 'react-toastify';
import { generateClient } from 'aws-amplify/api';

const subscribeEmailMutation = `
  mutation SendEmail($email: String!) {
    subscribeEmail(email: $email)
    {
        email
    }
  }
`;

interface EmailSubscribeProps {
  variant?: 'inline' | 'stacked';
  className?: string;
}

const EmailSubscribe: React.FC<EmailSubscribeProps> = ({ variant = 'inline', className = '' }) => {
  const [email, setEmail] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleFormSubmit = async (event: React.FormEvent) => {
    event.preventDefault();

    if (!email) return;

    setIsSubmitting(true);

    try {
      const input = { email };
      const client = generateClient();

      await client.graphql({
        query: subscribeEmailMutation,
        variables: input
      });

      toast.success('Email submitted successfully!');
      setEmail('');
    } catch (error) {
      toast.error(`Failed to subscribe: ${error}`);
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setEmail(event.target.value);
  };

  if (variant === 'inline') {
    return (
      <form onSubmit={handleFormSubmit} className={`flex flex-col sm:flex-row gap-3 items-center justify-center ${className}`}>
        <div className="relative w-full sm:w-auto sm:min-w-[300px]">
          <input
            type="email"
            value={email}
            onChange={handleChange}
            placeholder="Enter your email"
            required
            disabled={isSubmitting}
            className="w-full px-4 py-3 rounded-lg border-2 border-tal-slate-300 focus:border-tal-blue-500 focus:outline-none focus:ring-2 focus:ring-tal-blue-200 transition-all disabled:opacity-50 disabled:cursor-not-allowed"
          />
        </div>
        <button
          type="submit"
          disabled={isSubmitting}
          className="w-full sm:w-auto bg-tal-blue-600 hover:bg-tal-blue-700 disabled:bg-tal-slate-400 text-white font-medium py-3 px-8 rounded-lg transition-colors disabled:cursor-not-allowed whitespace-nowrap"
        >
          {isSubmitting ? 'Subscribing...' : 'Subscribe'}
        </button>
      </form>
    );
  }

  // Stacked variant
  return (
    <form onSubmit={handleFormSubmit} className={`space-y-3 ${className}`}>
      <div className="relative">
        <input
          type="email"
          value={email}
          onChange={handleChange}
          placeholder="Enter your email"
          required
          disabled={isSubmitting}
          className="w-full px-4 py-3 rounded-lg border-2 border-tal-slate-300 focus:border-tal-blue-500 focus:outline-none focus:ring-2 focus:ring-tal-blue-200 transition-all disabled:opacity-50 disabled:cursor-not-allowed"
        />
      </div>
      <button
        type="submit"
        disabled={isSubmitting}
        className="w-full bg-tal-blue-600 hover:bg-tal-blue-700 disabled:bg-tal-slate-400 text-white font-medium py-3 px-8 rounded-lg transition-colors disabled:cursor-not-allowed"
      >
        {isSubmitting ? 'Subscribing...' : 'Subscribe'}
      </button>
    </form>
  );
};

export default EmailSubscribe;
